import { Route } from '@angular/router';
import { LoginGuard, PermissionGuard } from '@simac/ui';

export const BranchInfoRoute: Route = {
  path: 'info',
  children: [
    {
      path: '',
      loadComponent: () => import('./pages/branchinfo.component').then((m) => m.BranchInfoComponent),
    },
  ],
  canActivate: [LoginGuard, PermissionGuard],
};
